module.exports = __webpack_public_path__ + "static/media/intelligent-store.90b8f250.svg";